import React from "react";
import { Grid } from "@material-ui/core";

import { bookingSystemTypeToString } from "features/planner/planner.mappers";
import ColumnDescription from "features/planner/report/helicopter/components/ColumnDescription";
import HeliReportClearRow from "features/planner/report/helicopter/components/HeliReportClearRow";

const ShoreBoundColumnDescription = ({ bookingSystemType }) => (
  <Grid container item wrap="nowrap" alignItems="center">
    <Grid item xs={true} zeroMinWidth>
      <ColumnDescription>
        {bookingSystemTypeToString(bookingSystemType)}
      </ColumnDescription>
    </Grid>
    <Grid item xs={4} zeroMinWidth>
      <ColumnDescription>Name</ColumnDescription>
    </Grid>
    <Grid item xs={true} zeroMinWidth>
      <ColumnDescription>Date</ColumnDescription>
    </Grid>
    <Grid item xs={true} zeroMinWidth>
      <ColumnDescription>Departure</ColumnDescription>
    </Grid>
    <Grid item>
      <HeliReportClearRow visible={false} />
    </Grid>
  </Grid>
);

export default ShoreBoundColumnDescription;
